import $ from 'jquery';

$(function () {
    if ($('#teamPage').length) {
        $('.manager-Profile').on('click', '.close-btn', function (e) {
            $('.manager-Profile').removeClass('show');
            $('.team-div').removeClass('blured');
        });

        $(document).on('keydown', function (ev) {
            if (event.key == "Escape") {
                $('.manager-Profile').removeClass('show');
                $('.team-div').removeClass('blured');
            }
        });

        $("#btnCareerSubmit").prop("disabled", true);
        $('#btnCareerSubmit').addClass("grey");
        $("#btnSubmit").prop("disabled", true);
        $('#btnSubmit').addClass("grey");
        $(":input").inputmask();
        $("#form-phone").inputmask("(999) 999 9999");
        $("#form-cphone").inputmask("(999) 999 9999");

        $('#btnSubmit').click(function (e) {
            var captchaResponse = "";
            if ($("#g-recaptcha-response-1").length) {
                captchaResponse = $("#g-recaptcha-response-1").val();
            }
            else
                captchaResponse = $("#g-recaptcha-response").val();

            if (captchaResponse.length == 0) {
            }
            else {
                var $form = $(this);

                if (!$form.valid) return false;
            e.preventDefault();

                var formData = new FormData();
                formData.append("form-email", $("#form-email").val());
                formData.append("form-name", $("#form-name").val());
                formData.append("form-phone", $("#form-phone").val());
                formData.append("message", $("#message").val());
                formData.append("form-to-email", $("#form-to-email").val());

                $.ajax({
                    type: 'POST',
                    cache: false,
                    url: '/SubmitEmailForm',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        if (response == "ok") {
                            alert("Contact form submitted successfully");
                            $('#contactform')[0].reset();
                            grecaptcha.reset();
                        }
                        else {
                            alert("There was an error when trying to submitting the contact form.");
                        }
                    }
                });
            }
        });

        $("#btnCareerSubmit").click(function (e) {
            var captchaResponse = $("#g-recaptcha-response").val();
            if (captchaResponse.length == 0) {
            }
            else {
                var $form = $(this);

                if (!$form.valid) return false;

                e.preventDefault();
                var formData = new FormData();
                formData.append("form-email", $("#form-cemail").val());
                formData.append("form-name", $("#form-cname").val());
                formData.append("form-phone", $("#form-cphone").val());
                formData.append("message", $("#cmessage").val());

                $.ajax({
                    type: 'POST',
                    cache: false,
                    url: '/SubmitCareerEmailForm',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        if (response == "ok") {
                            alert("Contact form submitted successfully");
                            $('#careercontactform')[0].reset();
                            grecaptcha.reset();
                        }
                        else {
                            alert("There was an error when trying to submitting the contact form.");
                        }
                    }
                });
            }
        });
    }

    if ($('#team_hero_section').length) {
        console.log("Checking this!!!");
        $(document).ready(function () {
            $("#sctInfoSection").css("background-image", "url(" + $("#sctInfoSection").data("dark") + ")");

            var value = $("#hidBackgroundImage").val();
            console.log("hidBackgroundImage on load: " + value);

            $('.manager-Profile').on('click', '.close-btn', function (e) {
                $('.manager-Profile').removeClass('show');
                $('.team-div').removeClass('blured');
            });
        });
    }

    if ($('#team_members').length) {
        var width = $(window).width();
        var currentIndex = 6;
        var fullLength = $('section.result-loan-section  div.loan-cards--wrapper div.loan-cards__item').length;
        $('section.result-loan-section  div.loan-cards--wrapper div.loan-cards__item').hide();

        if (width >= 1440) {
            $('section.result-loan-section  div.loan-cards--wrapper div.loan-cards__item').slice(0, 9).show();
            currentIndex = 9;
        }
        else {
            $('section.result-loan-section  div.loan-cards--wrapper div.loan-cards__item').slice(0, 6).show();
        }
        var btnMore = $("#seeMore");

        if (fullLength <= currentIndex) {
            btnMore.hide();
        } else {
            btnMore.show();
        }

        btnMore.click(function (e) {
            e.preventDefault();
            $('section.result-loan-section  div.loan-cards--wrapper div.loan-cards__item').show();
            var currentLength = $('section.result-loan-section  div.loan-cards--wrapper div.loan-cards__item').length;

            if (currentLength >= fullLength) {
                btnMore.hide();
            } else {
                btnMore.show();
            }
        });
    }
});

window.EnableSubmit = function () {
    $("#btnSubmit").prop("disabled", false);
    $('#btnSubmit').addClass("enable");
    $('#btnSubmit').removeClass("grey");
}
window.EnableCareerSubmit = function () {
    $("#btnCareerSubmit").prop("disabled", false);
    $('#btnCareerSubmit').addClass("enable");
    $('#btnCareerSubmit').removeClass("grey");
}
